import React, { useEffect, useState } from "react";
import { matchPath, Outlet, useLocation, useNavigate } from "react-router-dom";
import { RouterConfig } from "../../config";
import Tabs from "../../map4dUI/components/tabs/tabs";
import Bottom from "./bottom";
import Describe from "./describe";
import Header from "./header";
import "./layout.scss";



const routeTabs = [
    {
        value: 1,
        route: RouterConfig.policy.route + "/*"
    },
    {
        value: 2,
        route: RouterConfig.rules.route + "/*"
    }
]
function Layout() {
    const location = useLocation()
    const navigate = useNavigate()

    const [valueTabs, setValueTabs] = useState(1)
    const [isHiden, setIsHiden] = useState(false)

    const handleChange = (value) => {
        setValueTabs(value)
        value === 1 && navigate(RouterConfig.policy.route)
        value === 2 && navigate(RouterConfig.rules.route)
    }
    useEffect(() => {
        let active = routeTabs?.find(t => {
            return matchPath({ path: t.route }, location.pathname)
        })
        setValueTabs(active?.value)
    }, [location.pathname])
    const getNavbarTogglerOpen = (bool) => {
        setIsHiden(bool)
    }
    const Horizontal = () => <div className='horizontalLine' />

    return (

        <div className="layoutPolicies">
            <Header onChange={getNavbarTogglerOpen} />
            <>
                {isHiden && <div className='horizontalLineMobile' />}
            </>
            {
                !isHiden &&
                <>
                    <Horizontal />
                    <>
                        <div className='container'>
                            <Describe />
                            <div className="tabswrap">
                                <Tabs
                                    options={
                                        [{ value: 1, name: 'Chính sách của Map4D ' }, { value: 2, name: 'Điều khoản dịch vụ của Map4D' }]
                                    }
                                    onChange={handleChange}
                                    value={valueTabs}
                                />
                            </div>

                            <Horizontal />
                            <>
                                <Outlet />
                            </>
                        </div>
                    </>
                    <Horizontal />
                    <Bottom />
                </>
            }

        </div>
    );
}

Layout.propTypes = {};

export default Layout;
